import { useEffect, useState } from 'react'
import { Typography, Button } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import { useTranslation } from 'react-i18next'
import { ColStack } from 'components/atoms/container/InCardStack'
import { IconContainer } from 'components/atoms/Icons'
import {
  EyebrowText,
  NextSession
} from 'components/molecules/home/CurrentPathMolecules'
import HikingIcon from '@mui/icons-material/Hiking'
import { JOURNEY } from 'routes/constants'
import { useNavigate } from 'react-router-dom'
import { MilestoneBox } from 'components/molecules/home/PathCardMolecules'
import { getLocalUser } from 'utils/localStorage'
import { getCurrentL1MilestoneWithCohortSession } from 'utils/getSupportingInfo'

const CurrentPathMilestones = ({ goal, leaderboardShown }) => {
  const { t } = useTranslation()
  const user = getLocalUser()
  const navigate = useNavigate()
  const l1Milestones = goal?.l1Steps?.slice(0, -1) || []
  const [currentL1Milestone, setCurrentL1Milestone] = useState(null)

  useEffect(() => {
    const fetchGoalSessions = async () => {
      const res = await getCurrentL1MilestoneWithCohortSession(goal)
      setCurrentL1Milestone(res?.currentL1Milestone)
    }
    if (goal) {
      if (user?.isCohortUser) fetchGoalSessions()
      else setCurrentL1Milestone(goal?.stats?.currentL1Milestone)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goal])

  const TimeText = ({ time, unit }) => (
    <RowStack spacing={2} width={'auto'}>
      <Typography variant='h2' lineHeight={'110%'}>
        {time}
      </Typography>
      <Typography color='textSecondary' fontWeight={500} lineHeight={'140%'}>
        {unit}
      </Typography>
    </RowStack>
  )

  const FormatEstimatedTime = ({ time }) => {
    const mins = Math.floor(time / 60)
    const sec = time % 60
    return (
      <ColStack spacing={0} style={{ marginTop: 8 }}>
        <RowStack spacing={4}>
          <TimeText time={mins} unit={'min'} />
          <TimeText time={sec} unit={'sec'} />
        </RowStack>
        <EyebrowText textTransform={'none'} lineHeight={'150%'}>
          {t('home.estimatedTime')}
        </EyebrowText>
      </ColStack>
    )
  }

  return (
    <ColStack spacing={8} flex={1}>
      {goal.completed ? (
        <>
          <EyebrowText>{t('pathsAndModels.milestones')}</EyebrowText>

          {l1Milestones.map(milestone => (
            <MilestoneBox
              key={milestone.id}
              milestone={milestone}
              isCompleted={true}
              inverseColors={true}
            />
          ))}
        </>
      ) : (
        <>
          <NextSession goal={goal} currentL1Milestone={currentL1Milestone} />

          <ColStack
            spacing={0}
            gap={12}
            sx={
              !leaderboardShown
                ? {
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                  }
                : {}
            }>
            {goal?.stats?.nexL2tMilestone && (
              <>
                <ColStack spacing={4} flex={1}>
                  <ColStack spacing={0}>
                    <EyebrowText>{t('home.nextUp')}</EyebrowText>
                    <Typography variant='h3'>
                      {goal.stats.nexL2tMilestone?.name}
                    </Typography>
                  </ColStack>

                  {goal.stats.nexL2tMilestone?.lengthSeconds > 0 && (
                    <FormatEstimatedTime
                      time={goal.stats.nexL2tMilestone?.lengthSeconds}
                    />
                  )}
                </ColStack>
              </>
            )}

            {!goal.completed && !goal.opensAt && (
              <Button
                onClick={() => navigate(JOURNEY)}
                sx={[
                  {
                    '& .MuiButton-startIcon': {
                      marginRight: 2
                    }
                  },
                  !leaderboardShown && {
                    marginRight: 20,
                    marginTop: 20
                  }
                ]}
                startIcon={<IconContainer icon={<HikingIcon />} />}>
                {t('pathsAndModels.jumpBackIn')}
              </Button>
            )}
          </ColStack>
        </>
      )}
    </ColStack>
  )
}

export default CurrentPathMilestones
